import { Controller } from "@hotwired/stimulus";
//import "tom-select/dist/css/tom-select.css";

export default class extends Controller {

  connect() {
    var options = {
      headers: { 0: {sorter:false, filter:false}},
    };
    var extra_options = {
      filter_functions : {
        // Add these options to the select dropdown (regex example)
        1 : {
          "budget" : function(e, n, f, i) { return /budget/.test(e); },
          "tournament" : function(e, n, f, i) { return /tournament/.test(e); },
        }
      },
    };
    bindTablesorter($('.superbrew-results-table'), options, extra_options, '', true);
  }
}
